import { render } from "./MediaFooter.vue?vue&type=template&id=7bac8eea&scoped=true"
import script from "./MediaFooter.vue?vue&type=script&lang=js"
export * from "./MediaFooter.vue?vue&type=script&lang=js"

import "./MediaFooter.vue?vue&type=style&index=0&id=7bac8eea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bac8eea"]])

export default __exports__